
import { verifyWebhookSetup } from "./webhookUtils";

// Make sure type declaration is exported
export interface WebhookTestResult {
  success: boolean;
  step?: string;
  message: string;
  details?: any;
  error?: string;
}

// Main test function that can be called from browser console
export async function runStripeWebhookTest(): Promise<WebhookTestResult> {
  console.log("🔍 Starting Stripe webhook verification test...");
  
  try {
    // Step 1: Verify webhook configuration
    console.log("Step 1: Verifying webhook configuration...");
    const webhookVerification = await verifyWebhookSetup();
    
    if (!webhookVerification.success) {
      console.error("❌ Webhook verification failed:", webhookVerification.message);
      return {
        success: false,
        step: "verification",
        message: webhookVerification.message
      };
    }
    
    if (!webhookVerification.stripe_key_configured) {
      console.warn("⚠️ STRIPE_SECRET_KEY is not configured in Supabase secrets");
    } else {
      console.log("✅ STRIPE_SECRET_KEY is properly configured");
    }
    
    if (!webhookVerification.webhook_secret_configured) {
      console.warn("⚠️ STRIPE_WEBHOOK_SECRET is not configured in Supabase secrets");
    } else {
      console.log("✅ STRIPE_WEBHOOK_SECRET is properly configured");
    }
    
    console.log("🎉 Webhook test completed successfully!");
    return {
      success: true,
      details: webhookVerification,
      message: "Webhook verification completed. See console for details."
    };
  } catch (error) {
    console.error("❌ Test failed with exception:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : String(error),
      message: "Test failed with an exception. See console for details."
    };
  }
}

// Register the function globally - simplified approach
if (typeof window !== 'undefined') {
  // Single method registration to avoid conflicts
  try {
    Object.defineProperty(window, 'runStripeWebhookTest', {
      value: runStripeWebhookTest,
      writable: false,
      configurable: true,
      enumerable: true
    });
    
    console.log("✅ Webhook test function registered globally");
    
    // Verify registration worked
    setTimeout(() => {
      if (typeof (window as any).runStripeWebhookTest === 'function') {
        console.log("✅ Function confirmed accessible as window.runStripeWebhookTest()");
      } else {
        console.error("❌ Function registration failed");
      }
    }, 100);
  } catch (err) {
    console.error("❌ Failed to register webhook test function:", err);
  }
}

// Also make it available as a named export for imports
export { runStripeWebhookTest as default };
